// =============================================
// UDÁLOSTI (poplachy)
// =============================================
export const UDALOSTI_ALL_URL = '/api/udalosti';
export const UDALOSTI_AKTIVNI_URL = (deviceToken?: string) =>
    `/api/udalosti/aktivni${deviceToken ? `?deviceToken=${deviceToken}` : ''}`;
export const UDALOSTI_AKTIVNI_AUDIO_URL = (poplachId: number, deviceToken?: string) =>
    `/api/udalosti/${poplachId}/audio${deviceToken ? `?deviceToken=${deviceToken}` : ''}`;
export const UDALOSTI_DEAKTIVOVAT_URL = (id: number) => `/api/udalosti/${id}/deaktivovat`;
export const UDALOSTI_AKTIVOVAT_URL = (id: number) => `/api/udalosti/${id}/aktivovat`;
export const UDALOSTI_DELETE_URL = (id: number) => `/api/udalosti/${id}`;
export const UDALOSTI_DETAIL_URL = (id: number) => `/api/udalosti/${id}/detail`;
export const UDALOSTI_RESEND_NOTIFIKACE_URL = (id: number) => `/api/udalosti/${id}/resend-notifikace`;
export const UDALOSTI_PRINT_STATUS_URL = (id: number) => `/api/udalosti/${id}/print-status`;
export const UDALOSTI_PRINT_URL = (id: number) => `/api/udalosti/${id}/print`;
export const UDALOSTI_PDF_URL = (id: number) => `/api/udalosti/${id}/pdf`;
export const UDALOSTI_PDF_PREVIEW_URL = '/api/udalosti/pdf-preview';
export const UDALOSTI_TEST_WEBPUSH_URL = '/api/udalosti/test-webpush';
export const UDALOSTI_TYPES_URL = '/api/udalosti/types';
export const UDALOSTI_AKTIVNI_AUDIO_BASE_URL = '/api/udalosti/aktivni/audio';
export const UDALOSTI_AKTIVNI_POSLEDNI_HODINA_URL = '/api/udalosti/aktivni-posledni-hodina';
export const UDALOSTI_ROUTE_URL = (id: number, deviceToken?: string) =>
    `/api/udalosti/${id}/route${deviceToken ? `?deviceToken=${deviceToken}` : ''}`;
export const UDALOSTI_TECHNIKA_URL = (id: number, deviceToken?: string) =>
    `/api/udalosti/${id}/technika${deviceToken ? `?deviceToken=${deviceToken}` : ''}`;
export const UDALOSTI_NOTIFIKACE_LOG_URL = (id: number) => `/api/udalosti/${id}/notifikace-log`;

// =============================================
// TYPY UDÁLOSTÍ
// =============================================
export const TYPY_UDALOSTI_URL = '/api/typy-udalosti';
export const TYPY_UDALOSTI_PODTYPY_URL = (typId: number) => `/api/typy-udalosti/${typId}/podtypy`;
export const TYPY_UDALOSTI_ALL_PODTYPY_URL = '/api/typy-udalosti/podtypy';

// =============================================
// ODPOVĚDI
// =============================================
export const ODPOVEDI_BY_POPLACH_ID_URL = (poplachId: number, deviceToken?: string) =>
    `/api/poplach/${poplachId}${deviceToken ? `?deviceToken=${deviceToken}` : ''}`;
export const ODPOVEDI_POST_URL = (poplachId: number, token: string) =>
    `/api/poplach/${poplachId}/odpoved?token=${token}`;
export const ODPOVEDI_BY_POPLACH_ID_AND_TOKEN_URL = (poplachId: number, token: string) =>
    `/api/poplach/${poplachId}/odpoved?token=${token}`;
export const POPLACH_STATUS_URL = '/api/poplach/status';

// =============================================
// KONFIGURACE
// =============================================
export const REFRESH_PAGE = (deviceToken?: string) =>
    `/api/konfigurace/refresh-page${deviceToken ? `?deviceToken=${deviceToken}` : ''}`;
export const KONFIGURACE_ALL_URL = '/api/konfigurace';
export const KONFIGURACE_BY_KEY_URL = (klic: string) => `/api/konfigurace/${klic}`;
export const APP_CONFIG_URL = '/api/konfigurace/app-config';

// =============================================
// STATISTIKY
// =============================================
export const UDALOSTI_STATISTIKY_URL = '/api/udalosti/statistiky';
export const STATISTIKA_POPLACHY_URL = '/api/statistika/poplachy';
export const STATISTIKA_BASE_URL = '/api/statistika';
export const STATISTIKA_DATUM_URL = (datum: string) => `/api/statistika/datum/${datum}`;
export const STATISTIKA_MOJE_URL = '/api/statistika/moje';
export const STATISTIKA_UZIVATEL_URL = (id: number) => `/api/statistika/uzivatel/${id}`;
export const STATISTIKA_TYM_GRAFY_URL = '/api/statistika/tym/grafy';

// =============================================
// DASHBOARD
// =============================================
export const DASHBOARD_STATS_URL = '/api/dashboard/stats';

// =============================================
// REPORTS
// =============================================
export const REPORTS_SOUHRN_URL = '/api/reports/souhrn';
export const REPORTS_SOUHRN_CLEN_URL = '/api/reports/souhrn/clen';
export const REPORTS_EXPORT_XLSX_URL = '/api/reports/export/xlsx';
export const REPORTS_EXPORT_PDF_URL = '/api/reports/export/pdf';
export const REPORTS_DETAIL_URL = '/api/reports/detail';

// =============================================
// AUTHENTICATION
// =============================================
export const AUTH_LOGIN_URL = '/api/auth/login';
export const AUTH_LOGOUT_URL = '/api/auth/logout';
export const AUTH_REFRESH_URL = '/api/auth/refresh';
export const AUTH_LOGOUT_ALL_URL = '/api/auth/logout-all';
export const AUTH_SESSIONS_URL = '/api/auth/sessions';
export const AUTH_REGISTER_URL = '/api/auth/register';
export const AUTH_CHANGE_PASSWORD_URL = '/api/auth/change-password';
export const AUTH_ME_URL = '/api/auth/me';
export const AUTH_SET_PIN_URL = '/api/auth/set-pin';
export const AUTH_FORGOT_PASSWORD_URL = '/api/auth/forgot-password';

// =============================================
// DEVICES
// =============================================
export const DEVICES_URL = '/api/devices';
export const DEVICE_BY_ID_URL = (deviceId: number) => `/api/devices/${deviceId}`;

// =============================================
// SETUP (Initial Configuration)
// =============================================
export const AUTH_SETUP_STATUS_URL = '/api/auth/setup/status';
export const AUTH_SETUP_URL = '/api/auth/setup';

// =============================================
// ADMIN - USERS
// =============================================
export const ADMIN_USERS_URL = '/api/admin/users';
export const ADMIN_USER_BY_ID_URL = (id: number) => `/api/admin/users/${id}`;
export const ADMIN_USER_RESET_PASSWORD_URL = (id: number) => `/api/admin/users/${id}/reset-password`;
export const ADMIN_USER_TOGGLE_STATUS_URL = (id: number) => `/api/admin/users/${id}/toggle-status`;
export const ADMIN_USER_ROLE_URL = (id: number) => `/api/admin/users/${id}/role`;
export const ADMIN_USERS_ADMINS_URL = '/api/admin/users/admins';
export const ADMIN_USERS_SEARCH_URL = '/api/admin/users/search';
export const ADMIN_USER_PIN_URL = (id: number) => `/api/admin/users/${id}/pin`;
export const ADMIN_USER_TEST_NOTIFICATION_URL = (id: number) => `/api/admin/users/${id}/test-notification`;
export const ADMIN_USER_RESET_TEST_LIMIT_URL = (id: number) => `/api/admin/users/${id}/reset-test-limit`;
export const ADMIN_USER_TEST_HISTORY_URL = (id: number) => `/api/admin/users/${id}/test-history`;
export const ADMIN_USER_BULK_SET_PIN_URL = '/api/admin/users/bulk-set-pin';
export const ADMIN_USER_BULK_DELETE_PIN_URL = '/api/admin/users/bulk-delete-pin';
export const ADMIN_USER_SEND_INVITATION_URL = (id: number) => `/api/admin/users/${id}/send-invitation`;

// =============================================
// ADMIN - HEALTH
// =============================================
export type HealthComponent = 'all' | 'database' | 'email' | 'fcm' | 'tts' | 'mqtt-gateway' | 'devices';
export const ADMIN_HEALTH_URL = (component?: HealthComponent) =>
    `/api/admin/health${component && component !== 'all' ? `/${component}` : ''}`;

// =============================================
// ADMIN - AUDIT
// =============================================
export const ADMIN_AUDIT_URL = '/api/admin/audit';
export const ADMIN_AUDIT_RECENT_URL = '/api/admin/audit/recent';
export const ADMIN_AUDIT_STATISTICS_URL = '/api/admin/audit/statistics';
export const ADMIN_AUDIT_EXPORT_CSV_URL = '/api/admin/audit/export/csv';
export const ADMIN_AUDIT_CLEANUP_URL = '/api/admin/audit/cleanup';

// =============================================
// ADMIN - KONFIGURACE
// =============================================
export const ADMIN_KONFIGURACE_UPDATE_URL = (klic: string) => `/api/admin/konfigurace/${klic}`;
export const ADMIN_KONFIGURACE_TRIGGER_REFRESH_URL = '/api/admin/konfigurace/trigger-refresh';

// =============================================
// LOKACE (autocomplete)
// =============================================
export const LOKACE_SEARCH_URL = '/api/lokace/search';

// =============================================
// JEDNOTKA
// =============================================
export const JEDNOTKA_URL = '/api/jednotka';
export const JEDNOTKA_LOGO_URL = '/api/jednotka/logo';

// =============================================
// DEVICE TOKENS
// =============================================
export const DEVICE_TOKEN_CREATE_URL = '/api/konfigurace/device-token';
export const DEVICE_TOKENS_LIST_URL = '/api/konfigurace/device-tokens';
export const DEVICE_TOKEN_DELETE_URL = (tokenId: number) => `/api/konfigurace/device-token/${tokenId}`;
export const DEVICE_TOKEN_UPDATE_URL = (tokenId: number) => `/api/konfigurace/device-token/${tokenId}`;
export const DEVICE_TOKEN_THEME_URL = (token: string) => `/api/konfigurace/device-token/theme?token=${token}`;

// =============================================
// WEB PUSH NOTIFICATIONS
// =============================================
export const PUSH_VAPID_PUBLIC_KEY_URL = '/api/push/vapid-public-key';
export const PUSH_SUBSCRIBE_URL = '/api/push/subscribe';
export const PUSH_UNSUBSCRIBE_URL = '/api/push/unsubscribe';

// =============================================
// HYDRANTY
// =============================================
export const HYDRANTY_URL = '/api/hydranty';
export const HYDRANTY_INFO_URL = '/api/hydranty/info';
export const ADMIN_HYDRANTY_URL = '/api/admin/hydranty';
export const ADMIN_HYDRANTY_GPX_URL = '/api/admin/hydranty/gpx';

// =============================================
// HYDRANTY — EVIDENCE (HO-24)
// =============================================
export const ADMIN_HYDRANT_BODY_URL = '/api/admin/hydranty/body';
export const ADMIN_HYDRANT_BODY_BY_ID_URL = (id: number) => `/api/admin/hydranty/body/${id}`;
export const ADMIN_HYDRANT_BODY_MAPA_URL = '/api/admin/hydranty/body/mapa';
export const ADMIN_HYDRANT_BODY_STATISTIKY_URL = '/api/admin/hydranty/body/statistiky';
export const ADMIN_HYDRANT_BODY_QR_IMAGE_URL = (id: number) => `/api/admin/hydranty/body/${id}/qr-image`;
export const ADMIN_HYDRANT_IMPORT_GEOJSON_URL = '/api/admin/hydranty/body/import/geojson';
export const ADMIN_HYDRANT_IMPORT_GPX_URL = '/api/admin/hydranty/body/import/gpx';
export const ADMIN_HYDRANT_CHECKLIST_URL = (id: number) => `/api/admin/hydranty/body/${id}/checklist`;
export const ADMIN_HYDRANT_KONTROLA_URL = (id: number) => `/api/admin/hydranty/body/${id}/kontrola`;
export const ADMIN_HYDRANT_KONTROLY_URL = (id: number) => `/api/admin/hydranty/body/${id}/kontroly`;
export const ADMIN_HYDRANT_KONTROLA_PDF_URL = (kontrolaId: number) => `/api/admin/hydranty/kontroly/${kontrolaId}/pdf`;
export const ADMIN_HYDRANT_KONTROLA_FOTO_URL = (kontrolaId: number) => `/api/admin/hydranty/kontroly/${kontrolaId}/fotografie`;
export const ADMIN_HYDRANT_FOTO_URL = (fotoId: number) => `/api/admin/hydranty/foto/${fotoId}`;
export const ADMIN_HYDRANT_PLANY_URL = '/api/admin/hydranty/plany';
export const ADMIN_HYDRANT_PLAN_BY_ID_URL = (planId: number) => `/api/admin/hydranty/plany/${planId}`;
export const ADMIN_HYDRANT_PLAN_REPORT_PDF_URL = (planId: number) => `/api/admin/hydranty/plany/${planId}/report-pdf`;
export const ADMIN_HYDRANT_ZAVADY_URL = '/api/admin/hydranty/zavady';
export const ADMIN_HYDRANT_ZAVADA_BY_ID_URL = (id: number) => `/api/admin/hydranty/zavady/${id}`;
export const ADMIN_HYDRANT_EXPORT_CSV_URL = '/api/admin/hydranty/export/csv';
export const ADMIN_HYDRANT_QR_STITKY_URL = '/api/admin/hydranty/export/qr-stitky';
export const ADMIN_HYDRANT_PLAN_POLOZKA_PRIRAZENI_URL = (polozkaId: number) => `/api/admin/hydranty/plany/polozky/${polozkaId}/prirazeni`;

// =============================================
// ADMIN - DEVICES (Raspberry Pi)
// =============================================
export const ADMIN_DEVICES_URL = '/api/admin/devices';
export const ADMIN_DEVICE_BY_ID_URL = (id: number) => `/api/admin/devices/${id}`;
export const ADMIN_DEVICE_PRINT_LOGS_URL = (id: number) => `/api/admin/devices/${id}/print-logs`;
export const ADMIN_DEVICE_PRINT_QUEUE_URL = (id: number) => `/api/admin/devices/${id}/print-queue`;
export const ADMIN_DEVICE_TEST_PRINT_URL = (id: number) => `/api/admin/devices/${id}/test-print`;
export const ADMIN_DEVICE_RETRY_PRINT_URL = (id: number, jobId: number) => `/api/admin/devices/${id}/retry-print/${jobId}`;
export const ADMIN_DEVICE_PREVIEW_ALERT_URL = (id: number) => `/api/admin/devices/${id}/preview-alert`;
export const ADMIN_DEVICE_STOP_PREVIEW_ALERT_URL = (id: number) => `/api/admin/devices/${id}/preview-alert`;
export const ADMIN_DEVICE_PREVIEW_ALERT_STATUS_URL = (id: number) => `/api/admin/devices/${id}/preview-alert/status`;
export const ADMIN_DEVICE_SETUP_PACKAGE_URL = '/api/admin/devices/setup-package';

// =============================================
// ADMIN - SPECIALIZACE
// =============================================
export const ADMIN_SPECIALIZACE_URL = '/api/admin/specializace';
export const ADMIN_SPECIALIZACE_BY_ID_URL = (id: number) => `/api/admin/specializace/${id}`;
export const ADMIN_SPECIALIZACE_BULK_ASSIGN_URL = '/api/admin/specializace/bulk-assign';

// =============================================
// ADMIN - TECHNIKA (Vozidla)
// =============================================
export const ADMIN_TECHNIKA_URL = '/api/admin/technika';
export const ADMIN_TECHNIKA_BY_ID_URL = (id: number) => `/api/admin/technika/${id}`;
export const ADMIN_TECHNIKA_FOTOGRAFIE_URL = (id: number) => `/api/admin/technika/${id}/fotografie`;
export const TECHNIKA_ACTIVE_URL = '/api/technika/active';
export const TECHNIKA_FOTOGRAFIE_URL = (id: number) => `/api/technika/${id}/fotografie`;
export const ADMIN_TECHNIKA_JIZDY_URL = (id: number) => `/api/admin/technika/${id}/jizdy`;
export const ADMIN_TECHNIKA_KONTROLY_URL = (id: number) => `/api/admin/technika/${id}/kontroly`;
export const ADMIN_TECHNIKA_KONTROLY_HISTORIE_URL = (id: number, typId: number) =>
    `/api/admin/technika/${id}/kontroly/historie/${typId}`;
export const ADMIN_TECHNIKA_KONTROLA_URL = (id: number) => `/api/admin/technika/kontroly/${id}`;

// =============================================
// AKCE (Plánované akce)
// =============================================
export const AKCE_URL = '/api/akce';
export const AKCE_BY_ID_URL = (id: number) => `/api/akce/${id}`;
export const AKCE_ODPOVED_URL = (id: number) => `/api/akce/${id}/odpoved`;
export const AKCE_NOTIFIKACE_URL = (id: number) => `/api/akce/${id}/notifikace`;
export const AKCE_NADCHAZEJICI_URL = '/api/akce/nadchazejici';

// =============================================
// DEVICE METRICS (Hardware monitoring)
// =============================================
export const DEVICE_METRICS_BY_HOSTNAME_URL = (hostname: string) =>
    `/api/device-metrics/hostname/${hostname}`;
export const DEVICE_METRICS_OVERVIEW_URL = '/api/device-metrics/overview';
export const ADMIN_DEVICE_METRICS_URL = (id: number) => `/api/admin/devices/${id}/metrics`;

// =============================================
// ADMIN - IoT MONITORING
// =============================================
// Objekty
export const ADMIN_IOT_OBJEKTY_URL = '/api/admin/iot/objekty';
export const ADMIN_IOT_OBJEKT_BY_ID_URL = (id: number) => `/api/admin/iot/objekty/${id}`;
export const ADMIN_IOT_OBJEKT_SIRENA_URL = (objektId: number, senzorId: number) =>
    `/api/admin/iot/objekty/${objektId}/sirena/${senzorId}`;
export const ADMIN_IOT_OBJEKT_PRIJEMCI_URL = (objektId: number) =>
    `/api/admin/iot/objekty/${objektId}/prijemci`;
export const ADMIN_IOT_OBJEKT_PRIJEMCE_BY_ID_URL = (objektId: number, prijemceId: number) =>
    `/api/admin/iot/objekty/${objektId}/prijemci/${prijemceId}`;

// Senzory
export const ADMIN_IOT_SENZOR_BY_ID_URL = (id: number) => `/api/admin/iot/senzory/${id}`;
export const ADMIN_IOT_SENZOR_MUTE_URL = (id: number) => `/api/admin/iot/senzory/${id}/mute`;
export const ADMIN_IOT_SENZOR_MUTE_BATCH_URL = '/api/admin/iot/senzory/mute-batch';
export const ADMIN_IOT_SENZOR_HISTORIE_URL = (id: number) => `/api/admin/iot/senzory/${id}/historie`;
export const ADMIN_IOT_SENZOR_TEPLOTA_URL = (id: number) => `/api/admin/iot/senzory/${id}/teplota`;
export const ADMIN_IOT_SENZOR_COMMAND_URL = (id: number) => `/api/admin/iot/senzory/${id}/command`;

// Capabilities
export const ADMIN_IOT_CAPABILITIES_URL = (objektId: number) =>
    `/api/admin/iot/senzory/capabilities/objekt/${objektId}`;

// Objekt Mute
export const ADMIN_IOT_OBJEKT_MUTE_URL = (objektId: number) => `/api/admin/iot/objekty/${objektId}/mute`;

// Dashboard
export const ADMIN_IOT_DASHBOARD_URL = '/api/admin/iot/dashboard';

// Konfigurace typu senzoru
export const ADMIN_IOT_SENZOR_TYPY_URL = '/api/admin/iot/senzor-typy';
export const ADMIN_IOT_SENZOR_TYP_BY_ID_URL = (id: number) => `/api/admin/iot/senzor-typy/${id}`;
export const ADMIN_IOT_SENZOR_TYPY_REFRESH_URL = '/api/admin/iot/senzor-typy/refresh-cache';

// MQTT Credentials
export const ADMIN_IOT_MQTT_CREDENTIALS_URL = '/api/admin/iot/mqtt-credentials';
export const ADMIN_IOT_MQTT_CREDENTIALS_PASSWORD_URL = '/api/admin/iot/mqtt-credentials/password';
export const ADMIN_IOT_MQTT_CREDENTIALS_REGENERATE_URL = '/api/admin/iot/mqtt-credentials/regenerate';
export const ADMIN_IOT_OBJEKT_ZIGBEE_CONFIG_URL = (objektId: number) =>
    `/api/admin/iot/objekty/${objektId}/zigbee-config`;
export const ADMIN_IOT_OBJEKT_BOOTSTRAP_CONFIG_URL = (objektId: number) =>
    `/api/admin/iot/objekty/${objektId}/bootstrap-config`;

// Globalni prijemci jednotky
export const ADMIN_IOT_SETTINGS_PRIJEMCI_URL = '/api/admin/iot/settings/prijemci';
export const ADMIN_IOT_SETTINGS_PRIJEMCE_BY_ID_URL = (prijemceId: number) =>
    `/api/admin/iot/settings/prijemci/${prijemceId}`;

// =============================================
// ADMIN - SIA EPS/EZS
// =============================================
// SIA Accounts
export const ADMIN_SIA_ACCOUNTS_URL = '/api/admin/sia/accounts';
export const ADMIN_SIA_ACCOUNT_PREVIEW_ID_URL = (objektId: number) =>
    `/api/admin/sia/accounts/preview-account-id/${objektId}`;
export const ADMIN_SIA_ACCOUNT_BY_ID_URL = (id: number) => `/api/admin/sia/accounts/${id}`;
export const ADMIN_SIA_ACCOUNT_PASSWORD_URL = (id: number) =>
    `/api/admin/sia/accounts/${id}/password`;
export const ADMIN_SIA_ACCOUNT_REGENERATE_PASSWORD_URL = (id: number) =>
    `/api/admin/sia/accounts/${id}/regenerate-password`;
export const ADMIN_SIA_ACCOUNTS_BY_OBJEKT_URL = (objektId: number) =>
    `/api/admin/sia/accounts/objekt/${objektId}`;
export const ADMIN_SIA_ACCOUNT_MUTE_URL = (id: number) => `/api/admin/sia/accounts/${id}/mute`;

// SIA Zones - endpoints jsou pod accounts
export const ADMIN_SIA_ZONES_URL = '/api/admin/sia/zones';
export const ADMIN_SIA_ZONE_BY_ID_URL = (id: number) => `/api/admin/sia/zones/${id}`;
export const ADMIN_SIA_ZONES_BY_ACCOUNT_URL = (accountId: number) =>
    `/api/admin/sia/accounts/${accountId}/zones`;
export const ADMIN_SIA_ZONE_CREATE_URL = (accountId: number) =>
    `/api/admin/sia/accounts/${accountId}/zones`;
export const ADMIN_SIA_ZONE_MUTE_URL = (id: number) => `/api/admin/sia/zones/${id}/mute`;

// SIA Events
export const ADMIN_SIA_EVENTS_BY_ACCOUNT_URL = (accountId: number, limit?: number) =>
    `/api/admin/sia/accounts/${accountId}/events${limit ? `?limit=${limit}` : ''}`;
export const ADMIN_SIA_EVENTS_BY_ZONE_URL = (zoneId: number, limit?: number) =>
    `/api/admin/sia/zones/${zoneId}/events${limit ? `?limit=${limit}` : ''}`;

// SIA Code Konfigurace
export const ADMIN_SIA_CODES_URL = '/api/admin/sia/codes';
export const ADMIN_SIA_CODE_BY_ID_URL = (id: number) => `/api/admin/sia/codes/${id}`;

// =============================================
// ADMIN - RELAY
// =============================================
export const ADMIN_RELAY_CONFIG_URL = '/api/admin/relay/config';
export const ADMIN_RELAY_CONFIG_BY_ID_URL = (id: number) => `/api/admin/relay/config/detail/${id}`;
export const ADMIN_RELAY_CONFIG_BY_OBJEKT_URL = (objektId: number) =>
    `/api/admin/relay/config/${objektId}`;
export const ADMIN_RELAY_COMMAND_URL = '/api/admin/relay/command';
export const ADMIN_RELAY_ON_URL = (objektId: number, relayZoneId: number) =>
    `/api/admin/relay/${objektId}/${relayZoneId}/on`;
export const ADMIN_RELAY_OFF_URL = (objektId: number, relayZoneId: number) =>
    `/api/admin/relay/${objektId}/${relayZoneId}/off`;
export const ADMIN_RELAY_PULSE_URL = (objektId: number, relayZoneId: number) =>
    `/api/admin/relay/${objektId}/${relayZoneId}/pulse`;

// =============================================
// DOSTUPNOST
// =============================================
export const DOSTUPNOST_JEDNOTKA_URL = '/api/dostupnost/jednotka';
export const DOSTUPNOST_HZS_SMENA_AKTUALNI_URL = '/api/dostupnost/hzs-smena-aktualni';
export const DOSTUPNOST_HISTORIE_URL = (id: number) => `/api/dostupnost/historie/${id}`;

// =============================================
// METEO (HO-37 — konzument BE MeteoController)
// =============================================
export const METEO_CISELNIK_ORP_URL = '/api/meteo/ciselnik/orp';
export const METEO_CONFIG_URL = '/api/meteo/config';
export const METEO_STATUS_URL = '/api/meteo/status';
// HO-94 E4 hydro endpointy
export const METEO_CISELNIK_HYDRO_URL = '/api/meteo/ciselnik/hydro-stanice';
export const METEO_HYDRO_CONFIG_URL = '/api/meteo/hydro/config';

// =============================================
// POHOTOVOST
// =============================================
export const POHOTOVOST_URL = '/api/pohotovost';
export const POHOTOVOST_VSECHNY_URL = '/api/pohotovost/vsechny';
export const POHOTOVOST_BY_ID_URL = (id: number) => `/api/pohotovost/${id}`;
export const POHOTOVOST_UZAVRIT_URL = (id: number) => `/api/pohotovost/${id}/uzavrit`;
export const POHOTOVOST_ODPOVEDI_URL = (id: number) => `/api/pohotovost/${id}/odpovedi`;

// =============================================
// ADMIN - KONTROLY
// =============================================
export const ADMIN_KONTROLY_TYPY_URL = '/api/admin/kontroly/typy';
export const ADMIN_KONTROLY_TYP_BY_ID_URL = (id: number) => `/api/admin/kontroly/typy/${id}`;
export const ADMIN_KONTROLY_URL = '/api/admin/kontroly';
export const ADMIN_KONTROLY_BY_ID_URL = (id: number) => `/api/admin/kontroly/${id}`;
export const ADMIN_KONTROLY_UZIVATEL_URL = (uzivatelId: number) => `/api/admin/kontroly/uzivatel/${uzivatelId}`;
export const ADMIN_KONTROLY_HISTORIE_URL = (uzivatelId: number, typId: number) =>
    `/api/admin/kontroly/uzivatel/${uzivatelId}/historie/${typId}`;
export const ADMIN_KONTROLY_PREHLED_URL = '/api/admin/kontroly/prehled';
export const ADMIN_KONTROLY_TYP_DASHBOARD_URL = (id: number) => `/api/admin/kontroly/typy/${id}/dashboard`;
export const ADMIN_KONTROLY_TYPY_SPLNITELNE_UCASTI_URL = '/api/admin/kontroly/typy/splnitelne-ucasti';
export const ADMIN_KONTROLY_TYP_AKTIVNI_URL = (id: number) => `/api/admin/kontroly/typy/${id}/aktivni`;
export const ADMIN_KONTROLY_TYPY_NAHLED_URL = '/api/admin/kontroly/typy/nahled';

// =============================================
// ADMIN - TECHNIKA KONTROLY PŘEHLED
// =============================================
export const ADMIN_TECHNIKA_OBSAZENI_NAHLED_URL = '/api/admin/technika/obsazeni-nahled';
export const UDALOST_OBSAZENI_URL = (id: number) => `/api/udalosti/${id}/obsazeni`;
export const ADMIN_TECHNIKA_KONTROLY_PREHLED_URL = '/api/admin/technika/kontroly/prehled';
export const TECHNIKA_DOSTUPNOST_PREHLED_URL = '/api/technika/dostupnost';
export const TECHNIKA_DOSTUPNOST_ODHLASIT_URL = (id: number) => `/api/technika/${id}/dostupnost`;
export const TECHNIKA_DOSTUPNOST_UKONCIT_URL = (id: number) => `/api/technika/dostupnost/${id}/ukoncit`;

// =============================================
// ŠABLONY UDÁLOSTÍ (Poplachové šablony)
// =============================================
export const SABLONY_UDALOSTI_URL = '/api/sablony-udalosti';
export const SABLONY_UDALOSTI_ALL_URL = '/api/sablony-udalosti/all';
export const SABLONY_UDALOSTI_BY_ID_URL = (id: number) => `/api/sablony-udalosti/${id}`;
export const SABLONY_UDALOSTI_VYHLASIT_URL = (id: number) => `/api/sablony-udalosti/${id}/vyhlasit`;
export const SABLONY_UDALOSTI_TOGGLE_STATUS_URL = (id: number) => `/api/sablony-udalosti/${id}/toggle-status`;

// =============================================
// PŘEDPOPLACHY
// =============================================
export const PREDPOPLACHY_AKTIVNI_URL = (deviceToken?: string) =>
    `/api/predpoplachy/aktivni${deviceToken ? `?deviceToken=${deviceToken}` : ''}`;
export const PREDPOPLACHY_BY_ID_URL = (id: number) => `/api/predpoplachy/${id}`;
export const PREDPOPLACHY_ODPOVEDI_URL = (id: number, deviceToken?: string) =>
    `/api/predpoplachy/${id}/odpovedi${deviceToken ? `?deviceToken=${deviceToken}` : ''}`;
export const PREDPOPLACHY_DEAKTIVOVAT_URL = (id: number) => `/api/predpoplachy/${id}/deaktivovat`;

// =============================================
// INVENTÁŘ VYBAVENÍ
// =============================================
export const ADMIN_INVENTAR_KATEGORIE_URL = '/api/admin/inventar/kategorie';
export const ADMIN_INVENTAR_KATEGORIE_BY_ID_URL = (id: number) => `/api/admin/inventar/kategorie/${id}`;
export const ADMIN_INVENTAR_KATEGORIE_REORDER_URL = '/api/admin/inventar/kategorie/reorder';
export const ADMIN_INVENTAR_VELIKOST_TYPY_URL = '/api/admin/inventar/velikost-typy';
export const ADMIN_INVENTAR_VELIKOST_TYP_BY_ID_URL = (id: number) => `/api/admin/inventar/velikost-typy/${id}`;
export const ADMIN_INVENTAR_TISK_URL = '/api/admin/inventar/polozky/tisk';
export const ADMIN_INVENTAR_POLOZKY_URL = '/api/admin/inventar/polozky';
export const ADMIN_INVENTAR_POLOZKA_BY_ID_URL = (id: number) => `/api/admin/inventar/polozky/${id}`;
export const ADMIN_INVENTAR_POLOZKA_HISTORIE_URL = (id: number) => `/api/admin/inventar/polozky/${id}/historie`;
export const ADMIN_INVENTAR_POLOZKA_PRIRAZENI_URL = (id: number) => `/api/admin/inventar/polozky/${id}/prirazeni`;
export const ADMIN_INVENTAR_POLOZKA_VYDEJ_URL = (id: number) => `/api/admin/inventar/polozky/${id}/vydej`;
export const ADMIN_INVENTAR_POLOZKA_VRACENI_URL = (id: number) => `/api/admin/inventar/polozky/${id}/vraceni`;
export const ADMIN_INVENTAR_POLOZKA_FOTKY_URL = (id: number) => `/api/admin/inventar/polozky/${id}/fotografie`;
export const ADMIN_INVENTAR_POLOZKA_FOTKA_URL = (id: number, fotoId: number) =>
    `/api/admin/inventar/polozky/${id}/fotografie/${fotoId}`;
export const ADMIN_INVENTAR_POLOZKA_FOTKA_DATA_URL = (id: number, fotoId: number) =>
    `/api/admin/inventar/polozky/${id}/fotografie/${fotoId}/data`;
export const ADMIN_INVENTAR_POLOZKA_PRIRAZENI_VOZIDLO_URL = (id: number) => `/api/admin/inventar/polozky/${id}/prirazeni-vozidlo`;
export const ADMIN_INVENTAR_VYSTROJNI_KARTA_URL = (uzivatelId: number) => `/api/admin/inventar/uzivatele/${uzivatelId}/vystrojni-karta`;
export const ADMIN_INVENTAR_CEKAJICI_NA_CISLO_URL = '/api/admin/inventar/polozky/cekajici-na-cislo';
export const ADMIN_INVENTAR_STATISTIKY_URL = '/api/admin/inventar/statistiky';
export const ADMIN_INVENTAR_KONFIGURACE_URL = '/api/admin/inventar/konfigurace';
export const ADMIN_INVENTAR_DOPLNENI_CISEL_URL = '/api/admin/inventar/polozky/doplneni-cisel';
export const ADMIN_INVENTAR_QR_URL = (id: number, size?: number) => `/api/admin/inventar/qr/${id}/generate?size=${size ?? 300}`;
export const ADMIN_INVENTAR_INVENTURA_URL = '/api/admin/inventar/inventura';
export const ADMIN_INVENTAR_INVENTURA_BY_ID_URL = (id: number) => `/api/admin/inventar/inventura/${id}`;
export const ADMIN_INVENTAR_INVENTURA_POLOZKY_URL = (id: number) => `/api/admin/inventar/inventura/${id}/polozky`;
export const ADMIN_INVENTAR_INVENTURA_SKEN_URL = (id: number) => `/api/admin/inventar/inventura/${id}/sken`;
export const ADMIN_INVENTAR_INVENTURA_DOKONCIT_URL = (id: number) => `/api/admin/inventar/inventura/${id}/dokoncit`;
export const ADMIN_INVENTAR_INVENTURA_CHYBEJICI_URL = (id: number) => `/api/admin/inventar/inventura/${id}/chybejici`;
export const ADMIN_INVENTAR_INVENTURA_NALEZENA_URL = (inventuraId: number, polozkaId: number) => `/api/admin/inventar/inventura/${inventuraId}/polozky/${polozkaId}/nalezena`;
export const ADMIN_INVENTAR_POLOZKA_KONTROLY_URL = (id: number) => `/api/admin/inventar/polozky/${id}/kontroly`;
export const ADMIN_INVENTAR_POLOZKA_KONTROLY_HISTORIE_URL = (id: number, typId: number) => `/api/admin/inventar/polozky/${id}/kontroly/historie/${typId}`;
export const ADMIN_INVENTAR_POLOZKA_KONTROLA_URL = (id: number, kontrolaId: number) => `/api/admin/inventar/polozky/${id}/kontroly/${kontrolaId}`;
export const INVENTAR_MOJE_URL = '/api/inventar/moje';

// =============================================
// ZPĚTNÁ VAZBA (Feedback)
// =============================================
export const FEEDBACK_URL = '/api/feedback';
export const DEMO_STATUS_URL = '/api/demo/status';

// =============================================
// IoT Detekce - globální vypnutí
// =============================================
export const ADMIN_IOT_DETEKCE_STAV_URL = '/api/admin/iot/detekce/stav';
export const ADMIN_IOT_DETEKCE_VYPNOUT_URL = '/api/admin/iot/detekce/vypnout';
export const ADMIN_IOT_DETEKCE_ZAPNOUT_URL = '/api/admin/iot/detekce/zapnout';

// =============================================
// NASTENKA (HO-2)
// =============================================
export const NASTENKA_URL = '/api/nastenka';
export const NASTENKA_BY_ID_URL = (id: number) => `/api/nastenka/${id}`;
export const NASTENKA_PIN_URL = (id: number) => `/api/nastenka/${id}/pin`;
export const NASTENKA_UNPIN_URL = (id: number) => `/api/nastenka/${id}/unpin`;

// =============================================
// EXTERNI OZNAMENI (HO-6)
// =============================================
export const ADMIN_EXTERNI_KONTAKTY_URL = '/api/admin/externi-kontakty';
export const ADMIN_EXTERNI_KONTAKT_BY_ID_URL = (id: number) => `/api/admin/externi-kontakty/${id}`;
export const ADMIN_RODINNY_PIN_URL = (userId: number) => `/api/admin/users/${userId}/rodinny-pin`;
export const RODINNY_PIN_URL = '/api/rodinny-pin';

// =============================================
// HO-22 — KONTROLY DOKUMENTY
// =============================================
export const ADMIN_KONTROLY_TYP_DOKUMENTY_URL = (typId: number) =>
    `/api/admin/kontroly/typy/${typId}/dokumenty`;
export const ADMIN_KONTROLY_DOKUMENT_BY_ID_URL = (id: number) =>
    `/api/admin/kontroly/dokumenty/${id}`;
export const ADMIN_KONTROLY_DOKUMENT_DOWNLOAD_URL = (id: number) =>
    `/api/admin/kontroly/dokumenty/${id}/download`;

// =============================================
// HO-22 — LÉKAŘSKÝ POSUDEK (download)
// =============================================
export const ADMIN_KONTROLY_POSUDEK_DOWNLOAD_URL = (userId: number) =>
    `/api/admin/kontroly/posudek/${userId}/download`;
export const ADMIN_KONTROLY_POSUDEK_HROMADNY_URL = '/api/admin/kontroly/posudek/hromadny';

// =============================================
// HO-22 — EMAIL NASTAVENÍ
// =============================================
export const ADMIN_EMAIL_CONFIG_STATUS_URL = '/api/admin/email/config-status';
export const ADMIN_EMAIL_LOG_URL = '/api/admin/email/log';
export const ADMIN_EMAIL_TEST_URL = '/api/admin/email/test';

// =============================================
// HO-22 — DATUM NAROZENÍ (self-service)
// =============================================
export const AUTH_DATUM_NAROZENI_URL = '/api/auth/datum-narozeni';

// =============================================
// HO-148/HO-151 - ZAZNAM ZASAHU (vlakno vyjezdu, osa, podklad, dokumentace)
// =============================================
export const ZASAH_OSA_URL = (id: number) => `/api/poplach/${id}/osa`;
// `typ` se posila malymi pismeny - server je sice bere case-insensitive
// (PodkladService#oznacDoZpravy), ale klient at je jednoznacny.
export const ZASAH_DO_ZPRAVY_URL = (id: number, typ: string, entitaId: number) =>
    `/api/poplach/${id}/do-zpravy/${typ.toLowerCase()}/${entitaId}`;
export const ZASAH_ZAMKNOUT_URL = (id: number) => `/api/poplach/${id}/vlakno/uzamknout`;
export const ZASAH_ODEMKNOUT_URL = (id: number) => `/api/poplach/${id}/vlakno/odemknout`;
export const ZASAH_PODKLAD_URL = (id: number) => `/api/poplach/${id}/podklad`;
export const ZASAH_PODKLAD_PDF_URL = (id: number) => `/api/poplach/${id}/podklad.pdf`;
export const ZASAH_DOKUMENTACE_URL = (id: number) => `/api/poplach/${id}/dokumentace`;

// =============================================
// HO-147 Task 4 - CHAT (kanal jednotky, zpravy)
// =============================================
// GET - insert-or-get kanalu jednotky (HO-143 Task 11). Feature flag tuhle cestu
// NEGATUJE (cteni), viz javadoc ChatController#kanalJednotky na BE.
export const CHAT_KANAL_JEDNOTKY_URL = '/api/chat/kanal-jednotky';
// GET (historie/feed) i POST (odeslani, multipart) na stejne ceste - viz
// KonverzaceController na BE.
export const KONVERZACE_ZPRAVY_URL = (konverzaceId: number) => `/api/konverzace/${konverzaceId}/zpravy`;
// HO-152 - POST, jednorazovy ticket (60 s) pro handshake /ws/chat. Refresh token
// jde v TELE, nikdy v query: v URL by skoncil v access logu proxy.
export const CHAT_WS_TICKET_URL = '/api/chat/ws-ticket';

export const ADMIN_IOT_ZARIZENI_URL = '/api/admin/iot/zarizeni';
export const ADMIN_IOT_ZARIZENI_BY_ID_URL = (id: number) => `/api/admin/iot/zarizeni/${id}`;
export const ADMIN_IOT_ZARIZENI_NEZARAZENA_URL = '/api/admin/iot/zarizeni/nezarazena';
export const ADMIN_IOT_ZARIZENI_NOVA_URL = '/api/admin/iot/zarizeni/nova';
export const ADMIN_IOT_ZARIZENI_KANALY_URL = (id: number) => `/api/admin/iot/zarizeni/${id}/kanaly`;
export const ADMIN_IOT_ZARIZENI_KANAL_URL = (id: number, kanalId: number) => `/api/admin/iot/zarizeni/${id}/kanaly/${kanalId}`;
export const ADMIN_IOT_ZARIZENI_PRAVIDLO_URL = (id: number, kanalId: number) => `/api/admin/iot/zarizeni/${id}/kanaly/${kanalId}/pravidlo`;
export const ADMIN_IOT_ZARIZENI_OVLADANI_URL = (id: number, kanalId: number) => `/api/admin/iot/zarizeni/${id}/kanaly/${kanalId}/ovladani`;
export const ADMIN_IOT_ZARIZENI_PRIKAZY_URL = (id: number, kanalId: number) => `/api/admin/iot/zarizeni/${id}/kanaly/${kanalId}/prikazy`;
export const ADMIN_IOT_ZARIZENI_STAV_URL = (id: number) => `/api/admin/iot/zarizeni/${id}/stav`;
export const ADMIN_IOT_ZARIZENI_ROZPOZNAT_URL = (id: number) => `/api/admin/iot/zarizeni/${id}/rozpoznat`;
export const ADMIN_IOT_KATALOG_URL = '/api/admin/iot/katalog';
